import { useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Button } from '../components/button';

const depressiveQuotes = [
  "My life is like a romantic comedy, minus the romance and the comedy",
  "I put the 'fun' in 'funeral' and the 'laughter' in 'manslaughter'",
  "The only thing I'm committed to is my commitment issues",
  "I tried to be normal once. Worst two minutes of my life",
  "I'm not having an existential crisis, this is just my personality now",
  "My anxiety has anxiety, and they both hate me",
  "I'm not saying I'm depressed, but I do relate to expired milk",
  "The light at the end of the tunnel is probably just someone with a flashlight bringing more problems",
  "My therapist says I need to stop being so negative. I told her that's just another thing I'm bad at",
  "I'm like a software update. Nobody wants me but I keep showing up anyway",
  "My life feels like a test I didn't study for, written in a language I don't speak",
  "Coffee: because adulting is hard and I need supervised medication",
  "I'm not saying I hate mornings, but if they were a person I'd file a restraining order",
];

export function SignInPage() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');
  
  const randomQuote = useMemo(() => {
    return depressiveQuotes[Math.floor(Math.random() * depressiveQuotes.length)];
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  function handleSignIn() {
    login();
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 dark:bg-avemio-dark-bg">
      <div className="w-full max-w-md rounded-lg bg-white dark:bg-avemio-dark-surface p-8 shadow-lg border border-gray-200 dark:border-avemio-dark-border">
        <div className="mb-6 flex justify-center">
          <img src="/avemio-logo.png" alt="Avemio Logo" className="h-24" />
        </div>

        <h1 className="mb-6 text-center text-3xl font-bold text-gray-900 dark:text-avemio-dark-text-primary">Employee Portal</h1>
        

        {reason === 'session_expired' && (
          <div className="mb-4 text-center rounded-md bg-yellow-50 dark:bg-yellow-900/30 p-3 border border-yellow-200 dark:border-yellow-800/50">
            <p className="text-sm text-yellow-800 dark:text-yellow-300">
              Your session has expired. Please sign in again.
            </p>
          </div>
        )}

        {reason === 'unauthorized' && (
          <div className="mb-4 text-center rounded-md bg-red-50 dark:bg-red-900/30 p-3 border border-red-200 dark:border-red-800/50">
            <p className="text-sm text-red-800 dark:text-red-300">
              You need to be signed in to access this page.
            </p>
          </div>
        )}

        <Button 
          onClick={handleSignIn} 
          className="w-full !py-3 !text-lg !bg-[#0b9fdb] hover:!bg-[#0a8ac4] !text-white !border-[#0a8ac4]"
        >
          Sign in
        </Button>

        <p className="mt-4 text-center text-xs italic text-gray-400 dark:text-avemio-dark-text-secondary">
          "{randomQuote}"
        </p>
      </div>
    </div>
  );
}
